import React, { Component, useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import { getCDNUrl } from "../../commons/CommonFunctions";
import "../../forum/main-forum.min.css";

import OwlCarousel from 'react-owl-carousel';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import MutualConnect from "../../commons/MutualConnect";
import Follow from "../../commons/Follow";
import { authService } from "../../auth";
import AuthModalComponent from "../../LoginExtra/AuthModalComponent";
import CommonHashTagsForum from './Common/CommonHashTagsForum';

function HashTagsForums(props) {
    const [userData, setUserData] = useState(authService.getUserDetailsFromLocalStorage());
    const [loginSuccess] = useState(authService.isAuthenticated());
    const [loginRequired, setLoginRequired] = useState(false);
    const [pathName, setPathName] = useState(false);

    const loginRequiredFunc = (slug) => {
        setLoginRequired(true);
        setPathName(slug);
        window.$("#loginModal").modal("show");
    }

    const handleLoginClose = () => {
        setLoginRequired(false);
        window.$("#loginModal").modal("hide");
    }

    return (
        <div id="hashTagForums" className="expHashSection forumpage">
            <h2 className="edtrdsk">Forum</h2>
            <div className="forumsection frtreding">
                <div className="row">
                    {props.forumListData && props.forumListData.slice(0, 4).map((item, index) => {
                        return (
                            <CommonHashTagsForum item={item} key={item.id} />
                        )
                    })
                    }
                </div>

                {props.forumListData && props.forumListData.length > 4 &&
                    <div className="btnblock text-center">
                        {loginSuccess === true ? ( props.hashTagType === 'global' ? 
                            (<Link className="btn morebtnsm" to={"/explore-hashtag/forums/" + props.tagName}>View All</Link>) : 
                        props?.hashTagType === "COMMUNITY" ? 
                            (<Link className="btn morebtnsm" to={"/community/hashtag/forums/" + props.tagName + "/" + props.userName}>View All</Link> ) :
                            (<Link className="btn morebtnsm" to={"/profile-hashtag/forums/" + props.tagName + "/" + props.userName}>View All</Link> )
                            
                            ) : ( <a href="javascript:void(0)" onClick={loginRequiredFunc.bind(this)} className="btn morebtnsm">View All</a> 
                        )}
                    </div>
                }
                {loginRequired === true ? (
                <AuthModalComponent handleLoginClose={handleLoginClose} pathname={"/explore-hashtag/forums/" + props.tagName} />
                ) : null}
            </div>
        </div>
    )
}

export default HashTagsForums;